import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=ec40ddd2&"
import script from "./EmailDetail.vue?vue&type=script&lang=ts&"
export * from "./EmailDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports